import React, { useEffect, useState } from 'react'
import { list, companyDataByID, setS3Bucket } from '../api/company';
import Loader from '../components/Loader';
import PopupModal from '../components/PopupModal';
import useUserStore from '../store/useUserStore';



export default function S3Bucket() {
    const { user } = useUserStore();
    const [loading, setLoading] = useState(false);
    const [companyName, setCompanyName] = useState("0");
    const [apiError, setApiError] = useState('');
    const [errorStatus, setErrorStatus] = useState("success");
    const [errors, setErrors] = useState({});

    const [showPopup, setShowPopup] = useState(false);
    const [popUpMessage, setPopUpMessage] = useState({ "title": "", "text": "" })
    const [onConfirmAction, setOnConfirmAction] = useState(null);

    const [option, setOption] = useState([{
        "id": "0",
        "companyName": "Please select company"
    }]);

    let formInput = {
        "AWS_REGION": "",
        "AWS_BUCKET_NAME": "",
        "AWS_SECRET": "",
        "AWS_ID": "",
        "cID": "",

    };
    const [formData, setFormData] = useState(formInput);

    const validate = () => {
        const newErrors = {};

        if (!formData.AWS_BUCKET_NAME) newErrors.AWS_BUCKET_NAME = 'AWS Bucket name is required';
        if (!formData.AWS_ID) newErrors.AWS_ID = 'AWS ID is required';
        if (!formData.AWS_REGION) newErrors.AWS_REGION = 'AWS Region is required';
        if (!formData.AWS_SECRET) newErrors.AWS_SECRET = 'AWS Secret is required';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleCompanyChange = async (e) => {
        const { name, value } = e.target;

        setCompanyName(value);

        if (value !== "0") {
            setLoading(true);
            console.log("option", option, value);
            const result = option.find(c => c._id === value);
            let companyDataRes = await companyDataByID(result.clientID)
            setLoading(false);
            if (companyDataRes.status > 199 && companyDataRes.status < 400) {
                let s3Data = companyDataRes.data.data?.S3Bucket;
                if (s3Data !== undefined && s3Data !== null) {
                    setFormData({
                        ...formData,
                        AWS_REGION: s3Data.AWS_REGION,
                        AWS_BUCKET_NAME: s3Data.AWS_BUCKET_NAME,
                        AWS_SECRET: s3Data.AWS_SECRET,
                        AWS_ID: s3Data.AWS_ID,
                    })
                } else {
                    setFormData(formInput)
                }

            }
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));


        // Clear error for the field being typed
        if (errors[name]) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                [name]: '',
            }));
        }
    }

    const getCompanyList = async () => {
        setLoading(true);
        let data = await list();
        setLoading(false);
        if (data.status > 199 && data.status <= 399) {
            setOption([{ id: 0, companyName: "Please select company" },
            ...data.data.data.map(obj => ({
                ...obj,
                companyName: `${obj.companyName} (${obj?.clientID || obj?.email || ""})`,
                status: obj.status || 'Active' // If status doesn't exist or is falsy, set it to 'Active'
            })).sort((a, b) =>
                a.companyName.localeCompare(b.companyName, undefined, { sensitivity: "base" })
            )
            ]);

        }

    }
    const delay = ms => new Promise(resolve => setTimeout(resolve, ms));
    useEffect(() => {
        getCompanyList();
    }, []);

    useEffect(() => {
        const run = async () => {
            await delay(5000);
            setApiError("");
        };
        run();
    }, [apiError]);

    const submitData = async (e) => {
        e.preventDefault();

        if (!validate()) {
            setApiError("Please add required fields")
            setErrorStatus('danger')
            return;
        }

        if (companyName === "") {
            setApiError("Please select company ");
        }

        try {
            setLoading(true);

            let s3bucket = {
                AWS_REGION: formData.AWS_REGION,
                AWS_BUCKET_NAME: formData.AWS_BUCKET_NAME,
                AWS_SECRET: formData.AWS_SECRET,
                AWS_ID: formData.AWS_ID,
            }

            const result = option.find(c => c._id === companyName);

            let dbList = [];
            if (user.db === "tdr") {
                dbList = ["tdr"];
            } else {
                dbList = ["pro"];
            }
            let dataRes = await setS3Bucket(result.clientID, {
                "S3Bucket": s3bucket,
                "db": dbList,
            });
            if (dataRes.status > 199 && dataRes.status < 400) {
                setPopUpMessage({
                    "title": "Success",
                    "text": dataRes.data.message
                })
                setShowPopup(true);
            } else {
                setPopUpMessage({
                    "title": "Error",
                    "text": dataRes.message
                })
                setShowPopup(true);
            }

        } catch (error) {

        } finally {
            setLoading(false);
        }
    };


    return (
        <>
            {loading && <Loader />}
            <PopupModal
                isOpen={showPopup}
                data={popUpMessage}
                onClose={() => {
                    setShowPopup(false)
                    setPopUpMessage({
                        "title": "",
                        "text": ""
                    })
                }}
                onConfirm={onConfirmAction}
            />
            <div className="content-wrapper">
                {apiError && <div className={`alert alert-${errorStatus} mb-4`}> {apiError}</div>}

                <div className="form-group col-md-4">
                    <label htmlFor="exampleSelectGender">Company</label>
                    <select className="form-select" id="exampleSelectGender" name="companyName" value={companyName} onChange={handleCompanyChange}>
                        {option
                            .filter((obj) => obj.id !== "")
                            .map((obj) => (
                                <option key={obj.id} value={obj.id} >
                                    {obj.companyName}
                                </option>
                            ))}

                    </select>
                </div>

                <form onSubmit={submitData}>
                    <div className="row">
                        <div className="page-header">
                            <h3 className="page-title"> Add S3 Bucket Details </h3>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    {companyName !== "0" &&
                                        <button type="button" onClick={submitData} className="btn btn-primary me-2">Save</button>
                                    }

                                </ol>
                            </nav>
                        </div>
                    </div>

                    <div className="col-md-4 grid-margin stretch-card">
                        <div className="card">
                            <div className="card-body">
                                <h4 className="card-title">S3 Bucket Details</h4>

                                <div className="form-group">
                                    <label>AWS REGION</label>
                                    <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        placeholder="AWS REGION"
                                        name="AWS_REGION"
                                        value={formData.AWS_REGION}
                                        onChange={handleChange}
                                        aria-label="Username" />
                                    {errors.AWS_REGION && <span className="text-danger">{errors.AWS_REGION}</span>}
                                </div>
                                <div className="form-group">
                                    <label>AWS BUCKET NAME</label>
                                    <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        placeholder="AWS BUCKET NAME"
                                        name="AWS_BUCKET_NAME"
                                        value={formData.AWS_BUCKET_NAME}
                                        onChange={handleChange}
                                        aria-label="Username" />
                                    {errors.AWS_BUCKET_NAME && <span className="text-danger">{errors.AWS_BUCKET_NAME}</span>}
                                </div>
                                <div className="form-group">
                                    <label>AWS SECRET</label>
                                    <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        placeholder="AWS SECRET"
                                        name="AWS_SECRET"
                                        value={formData.AWS_SECRET}
                                        onChange={handleChange}
                                        aria-label="Username" />
                                    {errors.AWS_SECRET && <span className="text-danger">{errors.AWS_SECRET}</span>}
                                </div>
                                <div className="form-group">
                                    <label>AWS ID</label>
                                    <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        placeholder="AWS ID"
                                        name="AWS_ID"
                                        value={formData.AWS_ID}
                                        onChange={handleChange}
                                        aria-label="Username" />
                                    {errors.AWS_ID && <span className="text-danger">{errors.AWS_ID}</span>}
                                </div>


                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </>
    )
}
